import { render, staticRenderFns } from "./FeedDetail.vue?vue&type=template&id=7e4b6438&scoped=true"
import script from "./FeedDetail.vue?vue&type=script&lang=js"
export * from "./FeedDetail.vue?vue&type=script&lang=js"
import style0 from "./FeedDetail.vue?vue&type=style&index=0&id=7e4b6438&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4b6438",
  null
  
)

export default component.exports
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSeparator});
